// components/TechnologySelector.js
import React from 'react';
import { Paper, Typography, FormControl, InputLabel, Select, MenuItem, Box, Chip, OutlinedInput } from '@mui/material';

const VENDOR_COLORS = {
  'Palo Alto': '#8884d8',
  'Cisco': '#82ca9d',
  'Aruba': '#ffc658',
  'Juniper': '#ff7300',
  'AireSpring_Velo': '#4DAEFF'
};

export const TechnologySelector = ({ selectedVendors, onChange }) => (
  <Paper elevation={3} sx={{ p: 2 }}>
    <Typography variant="subtitle1" gutterBottom>
      SDWAN Technology Selection
    </Typography>
    <FormControl fullWidth>
      <InputLabel>Vendors</InputLabel>
      <Select
        multiple
        value={selectedVendors}
        onChange={onChange}
        input={<OutlinedInput label="Vendors" />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip
                key={value}
                label={value}
                style={{
                  backgroundColor: VENDOR_COLORS[value],
                  color: 'white',
                }}
              />
            ))}
          </Box>
        )}
      >
        {Object.keys(VENDOR_COLORS).map((vendor) => (
          <MenuItem key={vendor} value={vendor}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  backgroundColor: VENDOR_COLORS[vendor],
                }}
              />
              {vendor}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Paper>
);